import useConfigurationStore from '../store/configurationStore';
import OptionGroup from './OptionGroup';

/**
 * Generic step content — renders options for a given category.
 */
export default function StepContent({ categoryId }) {
    const { optionsByCategory } = useConfigurationStore();
    const options = optionsByCategory[categoryId] || [];

    if (options.length === 0) {
        return (
            <div className="ast-step-content ast-step-content--empty">
                <p>Geen opties beschikbaar in deze categorie.</p>
            </div>
        );
    }

    // Filter only active options.
    const activeOptions = options.filter(
        (opt) => opt.is_active === '1' || opt.is_active === 1
    );

    return (
        <div className="ast-step-content">
            <OptionGroup options={activeOptions} />
        </div>
    );
}
